import { BASE_10 } from "../constants";
import IKenoDraw from "../interfaces/IKenoDraw";
import IKenoTicketStatus from "../interfaces/IKenoTicketStatus";
import ITicket from "../interfaces/ITicket";

/**
 * Get the display status for a ticket
 *
 * @param ticket the ticket whose status we are getting
 * @param currentDraw the current draw being shown
 */
export default function getTicketStatus(ticket: ITicket, currentDraw: IKenoDraw): IKenoTicketStatus {
    const currentDrawId = parseInt(currentDraw.id, BASE_10);
    const ticketDrawId = ticket.event ? parseInt(ticket.event.externalId, BASE_10) : undefined;

    // Unknown state, assume upcoming
    if (!currentDrawId || !ticketDrawId) {
        return "upcoming";
    }

    if (currentDrawId < ticketDrawId) {
        return "upcoming";
    }

    if (currentDrawId === ticketDrawId) {
        return "live";
    }

    return "completed";
}



// WEBPACK FOOTER //
// ./src/utils/getTicketStatus.ts